import React from 'react';
import { forwardRef, chakra } from '@chakra-ui/react';
import { motion, isValidMotionProp } from 'framer-motion';

export const MotionText = motion(
  forwardRef((props, ref) => {
    const chakraProps = Object.fromEntries(
      // do not pass framer props to DOM element
      Object.entries(props).filter(([key]) => !isValidMotionProp(key))
    );
    return <chakra.p ref={ref} {...chakraProps} />;
  })
);
